export var TABS_CLASSNAMES_BY_TAB_BUTTONS_POSITION = {
  start: 'justify-start',
  middle: 'justify-center',
  end: 'justify-end',
  spread: 'justify-around'
};
export var TAB_CLASSNAMES_BY_SIZE = {
  s: 'h-40 px-16 font-subtitle4',
  m: 'h-56 px-16 font-subtitle2',
  l: 'h-64 px-16 font-h4'
};